module.exports = __webpack_public_path__ + "img/joinMeeting.6cab8902.gif";